import React from 'react';
import { makeStyles, shorthands } from '@fluentui/react-components';

import { useNavigate } from 'react-router-dom';
import styles from './NavigationButtons.module.css'; // Assuming you have a CSS file for additional styles


interface ButtonProps {
  label: string;
  icon: React.ReactNode;
  path: string;
}

interface NavigationButtonsProps {
  buttons: ButtonProps[];
  containerClassName?: string;
  buttonBoxClassName?: string;
  iconWrapperClassName?: string;
  labelClassName?: string;
}


const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  buttons,
  containerClassName = '',
  buttonBoxClassName = '',
  iconWrapperClassName = '',
  labelClassName = '',
}) => {
  const navigate = useNavigate();

  return (
    <div className={`${styles.container} ${containerClassName}`}>
      {buttons.map((btn) => (
        <div
          key={btn.label}
          className={`${styles.buttonBox} ${buttonBoxClassName}`}
          onClick={() => navigate(btn.path)}
        >
          <div className={`${styles.iconWrapper} ${iconWrapperClassName}`}>
            {btn.icon}
          </div>
          <div className={`${styles.label} ${labelClassName}`}>
            {btn.label}
          </div>
        </div>
      ))}
    </div>
  );
};


export default NavigationButtons;
